import React from 'react';
import { RiskScore } from '../../types';
import { Shield, TrendingUp, TrendingDown } from 'lucide-react';
interface RiskScoreBadgeProps {
  riskScore: RiskScore;
  size?: 'sm' | 'md' | 'lg';
  showDetails?: boolean;
}
export function RiskScoreBadge({
  riskScore,
  size = 'md',
  showDetails = false
}: RiskScoreBadgeProps) {
  const sizeClasses = {
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-1.5',
    lg: 'text-base px-4 py-2'
  };
  const colorClasses = {
    Low: 'bg-green-50 text-green-700 border-green-200',
    Medium: 'bg-yellow-50 text-yellow-700 border-yellow-200',
    High: 'bg-red-50 text-red-700 border-red-200'
  };
  const iconColorClasses = {
    Low: 'text-green-600',
    Medium: 'text-yellow-600',
    High: 'text-red-600'
  };
  return <div className="inline-block group relative" data-id="element-2514">
      <div className={`inline-flex items-center rounded-full font-bold border ${colorClasses[riskScore.level]} ${sizeClasses[size]}`} data-id="element-2515">
        <Shield className={`h-3 w-3 mr-1.5 ${iconColorClasses[riskScore.level]}`} data-id="element-2516" />
        {riskScore.level} Risk
        {size !== 'sm' && <span className="ml-1.5 opacity-75" data-id="element-2517">({riskScore.score})</span>}
      </div>

      {showDetails && <div className="absolute z-50 invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-all duration-200 bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 bg-gray-900 text-white text-xs rounded-lg p-4 shadow-xl" data-id="element-2518">
          <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-gray-900 rotate-45" data-id="element-2519"></div>

          <div className="space-y-2" data-id="element-2520">
            <div className="flex justify-between items-center pb-2 border-b border-gray-700" data-id="element-2521">
              <span className="font-bold" data-id="element-2522">Risk Assessment</span>
              <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold ${colorClasses[riskScore.level]}`} data-id="element-2523">
                {riskScore.level}
              </span>
            </div>

            <div className="space-y-1.5" data-id="element-2524">
              <div className="flex justify-between" data-id="element-2525">
                <span className="text-gray-400" data-id="element-2526">Income Stability</span>
                <span className="font-medium" data-id="element-2527">
                  {riskScore.factors.incomeStability}%
                </span>
              </div>
              <div className="flex justify-between" data-id="element-2528">
                <span className="text-gray-400" data-id="element-2529">Payment History</span>
                <span className="font-medium" data-id="element-2530">
                  {riskScore.factors.paymentHistory}%
                </span>
              </div>
              <div className="flex justify-between" data-id="element-2531">
                <span className="text-gray-400" data-id="element-2532">Employment</span>
                <span className="font-medium" data-id="element-2533">
                  {riskScore.factors.employmentType}
                </span>
              </div>
              <div className="flex justify-between" data-id="element-2534">
                <span className="text-gray-400" data-id="element-2535">Credit Score</span>
                <span className="font-medium" data-id="element-2536">
                  {riskScore.factors.creditScore}
                </span>
              </div>
            </div>

            <div className="pt-2 border-t border-gray-700" data-id="element-2537">
              <div className="flex items-center text-[10px] text-gray-400" data-id="element-2538">
                <Shield className="h-3 w-3 mr-1" data-id="element-2539" />
                {riskScore.confidence}% Confidence
              </div>
            </div>
          </div>
        </div>}
    </div>;
}